<script>
import { mapGetters } from 'vuex'

export default {
    name: 'AccountNotifications',
    computed: {
        ...mapGetters(['userResource'])
    },
    data() {
        return {
            optInAccount: null,
            optInMarketing: null,
            optInChangesMade: false,
        }
    },
    methods: {
        async onSaveNotifPrefs() {
            this.userResource.attributes.opt_in_account_updates = this.optInAccount
            this.userResource.attributes.opt_in_marketing_updates = this.optInMarketing
            await this.userResource.save()
            this.optInChangesMade = false
        }
    },
    mounted() {
        this.optInAccount = this.userResource.attributes.opt_in_account_updates
        this.optInMarketing = this.userResource.attributes.opt_in_marketing_updates
    }
}
</script>

<template>
    <div>
        <div class="mb-4">
            <h4 class="mb-1">Benachrichtigungen</h4>
            <p class="text-muted mb-0">Steuern Sie, wie und wann wir Sie kontaktieren.</p>
        </div>
        <b-card>
            <b-form-group class="mb-4">
                <b-form-checkbox v-model="optInAccount" @input="optInChangesMade = true" switch>
                    <span class="font-weight-bold d-block">Kontoaktualisierungen</span>
                    <small class="text-muted">
                        Transaktionsnachrichten im Zusammenhang mit Ihrem Konto, Bestellungen oder angeforderten Dienstleistungen — einschließlich Terminerinnerungen, Bestellbestätigungen und Kontobenachrichtigungen. Nachrichten- und Datenraten können anfallen. Antworten Sie mit HELP für Hilfe oder STOP, um sich abzumelden.
                    </small>
                </b-form-checkbox>
            </b-form-group>
            <b-form-group class="mb-4">
                <b-form-checkbox v-model="optInMarketing" @input="optInChangesMade = true" switch>
                    <span class="font-weight-bold d-block">Marketing &amp; Aktionen</span>
                    <small class="text-muted">
                        Sonderangebote, Rabatte und neue Produktaktualisierungen. Nachrichten- und Datenraten können anfallen. Antworten Sie mit HELP für Hilfe oder STOP, um sich abzumelden.
                    </small>
                </b-form-checkbox>
            </b-form-group>
            <b-button variant="primary" :disabled="!optInChangesMade" @click="onSaveNotifPrefs()">Einstellungen speichern</b-button>
        </b-card>
    </div>
</template>
